import PropTypes from 'prop-types'
import React from 'react'
import { defineMessages, injectIntl } from 'react-intl'
import SelectField from './SelectField/SelectField'

const newYearsDay = new Date(2016, 1, 1, 12)
const messages = defineMessages({
  day: {
    id: 'forms.day_select',
    defaultMessage: 'Day',
  },
})

const propTypes = {
  from: PropTypes.number,
  years: PropTypes.number,
  to: PropTypes.number,
  intl: PropTypes.object,
  format: PropTypes.oneOf([
    'numeric',
    '2-digit',
  ]),
}

const defaultProps = {
  format: 'numeric',
}

const DayField = ({ format, intl, ...rest }) => {
  const n = 31
  const dayOptions = [...Array(n)].map((x, i) => {
    const day = i + 1
    let dayString = day.toString()
    if (dayString.length < 2) { dayString = `0${dayString}` }

    return {
      label: intl.formatDate(newYearsDay.setDate(day), { day: format }),
      value: dayString,
    }
  })

  return (
    <SelectField
      {...rest}
      options={dayOptions}
      placeholder={intl.formatMessage(messages.day)}
    />
  )
}

DayField.defaultProps = defaultProps
DayField.propTypes = propTypes

export default injectIntl(DayField)



// WEBPACK FOOTER //
// ./src/components/forms/DayField.jsx